// zd-theme.js — Zero Dark theme DOM enhancements

// Move smart search to below the hero section.
// Falls back gracefully once zd-app.js KV cache clears and injects directly.
(function () {
  const SEARCH_SELECTOR = '.zd-search-wrapper, .zd-smart-search';
  const HERO_SELECTOR   = '.shopify-section:has(.zd-hero), .zd-hero, [data-section-type="zd-hero"]';

  function moveSearch() {
    const search = document.querySelector(SEARCH_SELECTOR);
    if (!search) return false;
    const hero = document.querySelector(HERO_SELECTOR);
    if (!hero) return false;
    const anchor = hero.closest('.shopify-section') || hero;
    if (anchor.nextElementSibling === search) return true; // already in place
    anchor.insertAdjacentElement('afterend', search);
    return true;
  }

  if (!moveSearch()) {
    const observer = new MutationObserver(() => { if (moveSearch()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  // ── Homepage category subtitle — show vehicle if selected ──
  const catSubtitle = document.querySelector('.zd-categories-subtitle');
  if (catSubtitle) {
    try {
      const v = JSON.parse(localStorage.getItem('zd_vehicle') || 'null');
      if (v?.year && v?.make && v?.model) {
        const parts = [v.year, v.make, v.model, v.submodel].filter(Boolean);
        catSubtitle.textContent = `For your ${parts.join(' ')}`;
        catSubtitle.classList.add('zd-categories-subtitle--vehicle');
      } else {
        catSubtitle.classList.remove('zd-categories-subtitle--vehicle');
      }
    } catch(e) {}
  }

  const hero = document.querySelector('.banner, .slideshow');
  if (hero) {
    hero.style.overflow = 'hidden';
    const fx = document.createElement('div');
    fx.className = 'zd-hero-fx';
    fx.setAttribute('aria-hidden', 'true');
    fx.innerHTML =
      '<div class="zd-fx-glow-1"></div>' +
      '<div class="zd-fx-glow-2"></div>' +
      '<div class="zd-fx-glow-3"></div>' +
      '<div class="zd-fx-beam-l"></div>' +
      '<div class="zd-fx-beam-r"></div>' +
      '<div class="zd-fx-scan"></div>' +
      '<div class="zd-fx-edge"></div>';
    hero.appendChild(fx);
  }

  // ── #2 Fitment badge + cart gate on product pages ─────────
  const fitmentEl = document.getElementById('zd-fitment-data');
  const badgeEl   = document.getElementById('zd-fitment-badge');

  function zdParseEngine(str) {
    if (!str) return { liter: null, cylinders: null };
    const m = str.match(/^(\d+\.?\d*)L(?:\s+(\d+)-Cyl)?/i);
    return m ? { liter: m[1], cylinders: m[2] || null } : { liter: null, cylinders: null };
  }

  // Legacy simple matcher — kept ONLY for the rare embedded-snapshot fallback in
  // zdResolveFitment (used when a product is missing brand_code/fitment_count metafields,
  // which basically never happens for a pushed product). The real, qualifier-aware match
  // (submodel/fuel type/drive type/etc, not just year/make/model+engine) now happens
  // server-side in /zd-fitment/check — see zdFetchFitment.
  function zdRowMatchesVehicle(f, vehicle) {
    if (String(f.year) !== String(vehicle.year)) return false;
    if ((f.make  || '').toLowerCase() !== vehicle.make.toLowerCase())  return false;
    if ((f.model || '').toLowerCase() !== vehicle.model.toLowerCase()) return false;
    if (f.liter && f.cylinders && vehicle.engine) {
      const { liter, cylinders } = zdParseEngine(vehicle.engine);
      if (liter && (String(f.liter) !== liter || String(f.cylinders) !== cylinders)) return false;
    }
    return true;
  }

  // Authoritative fitment: query the D1 fitment table by year/make/model + whatever other
  // qualifiers the vehicle knows (submodel, engine, fuel type, drive type, etc). D1 is the
  // single source of truth — no Shopify-metafield snapshot, no truncation. The server computes
  // the real verdict (fits / likely_fits+needs / neither) so every consumer of this endpoint
  // agrees — do not re-derive it here.
  const ZD_FIT_WORKER = 'https://zda-engine.tight-voice-31e4.workers.dev';
  const zdFitCache = {};

  async function zdFetchFitment(brand, pn, vehicle) {
    const qualKeys = ['submodel','liter','cylinders','fuel_type','drive_type','body_type','transmission','bed_type','bed_length_in','wheelbase_in'];
    const key = [brand, pn, vehicle.year, vehicle.make, vehicle.model, vehicle.fuel_family || '', ...qualKeys.map(k => vehicle[k] || '')].join('|').toLowerCase();
    if (zdFitCache[key]) return zdFitCache[key];
    const params = new URLSearchParams({ brand, pn, year: String(vehicle.year), make: vehicle.make, model: vehicle.model });
    if (vehicle.submodel) params.set('submodel', vehicle.submodel);
    if (vehicle.engine) {
      const { liter, cylinders } = zdParseEngine(vehicle.engine);
      if (liter) { params.set('liter', liter); if (cylinders) params.set('cylinders', cylinders); }
    } else {
      if (vehicle.liter)     params.set('liter', vehicle.liter);
      if (vehicle.cylinders) params.set('cylinders', vehicle.cylinders);
    }
    qualKeys.slice(3).forEach(k => { if (vehicle[k]) params.set(k, vehicle[k]); });
    // Authoritative enriched fuel family (three-scenario) — makes the badge verdict confident.
    if (vehicle.fuel_family) params.set('fuel_family', vehicle.fuel_family);
    const res  = await fetch(`${ZD_FIT_WORKER}/zd-fitment/check?${params}`);
    const data = await res.json();
    const result = {
      rows: data.rows || [], fits: !!data.fits, likely_fits: !!data.likely_fits,
      needs: data.needs || [], positions: data.positions || [], notes: data.notes || [], qualifiers: data.qualifiers || [],
    };
    zdFitCache[key] = result;
    return result;
  }

  // Resolve fitment for the current product+vehicle. Prefers D1 (brand+pn present);
  // falls back to the embedded snapshot only when D1 keys are unavailable.
  async function zdResolveFitment(vehicle) {
    const brand = badgeEl?.dataset.brand || '';
    const pn    = badgeEl?.dataset.pn || '';
    if (brand && pn) return zdFetchFitment(brand, pn, vehicle);
    const snapshot = fitmentEl ? JSON.parse(fitmentEl.textContent || '[]') : [];
    const matching = snapshot.filter(f => zdRowMatchesVehicle(f, vehicle));
    return { rows: snapshot, fits: matching.length > 0, likely_fits: false, needs: [], positions: [...new Set(matching.map(f => f.position).filter(Boolean))], notes: [] };
  }

  function zdProductHasFitment() {
    const count = parseInt(badgeEl?.dataset.fitmentCount || '', 10);
    if (Number.isFinite(count)) return count > 0;
    return (fitmentEl ? JSON.parse(fitmentEl.textContent || '[]') : []).length > 0;
  }

  // Human labels for the server's "needs" qualifier keys, used in the badge/modal copy.
  const ZD_NEEDS_LABEL = {
    submodel: 'trim/submodel', engine: 'engine', fuel_type: 'fuel type', drive_type: 'drive type',
    body_type: 'body type', transmission: 'transmission', bed_type: 'bed type',
    bed_length_in: 'bed length', wheelbase_in: 'wheelbase',
  };
  const zdNeedsText = needs => needs.map(k => ZD_NEEDS_LABEL[k] || k).join(' / ');

  async function zdRenderFitmentBadge() {
    if (!badgeEl) return;
    try {
      const vehicle = JSON.parse(localStorage.getItem('zd_vehicle') || 'null');
      const vLabel = vehicle ? `${vehicle.year} ${vehicle.make.toUpperCase()} ${vehicle.model.toUpperCase()}` : '';

      if (!zdProductHasFitment()) {
        badgeEl.innerHTML = '<div class="zd-fit-indicator zd-fit-universal">⬡ UNIVERSAL FIT — No Vehicle Restrictions</div>';
        return;
      }
      if (!vehicle?.year) {
        badgeEl.innerHTML = '<div class="zd-fit-indicator zd-fit-unknown zd-fit-open-btn" role="button" tabindex="0">⚠ SELECT YOUR VEHICLE TO VERIFY FITMENT</div>';
        return;
      }

      badgeEl.innerHTML = '<div class="zd-fit-indicator zd-fit-unknown">⬡ CHECKING FITMENT…</div>';
      const result = await zdResolveFitment(vehicle);
      const posLabel = (result.positions.length ? ` — ${result.positions.join(', ')}` : '') + ((result.qualifiers || []).length ? ` (${result.qualifiers.join(' OR ')})` : '');

      if (result.fits) {
        badgeEl.innerHTML = `<div class="zd-fit-indicator zd-fit-yes">✓ FITS YOUR ${vLabel}${posLabel}</div>`;
        zdTagVehicle();
      } else if (result.likely_fits) {
        badgeEl.innerHTML = `<div class="zd-fit-indicator zd-fit-warn zd-fit-open-btn" role="button" tabindex="0" data-needs="${result.needs.join(',')}">⚠ LIKELY FITS YOUR ${vLabel} — Select ${zdNeedsText(result.needs)} to confirm${posLabel} (click to select)</div>`;
      } else {
        const noteLabel = result.notes.length ? ` — ${result.notes[0]}` : '';
        badgeEl.innerHTML = `<div class="zd-fit-indicator zd-fit-no">✗ DOES NOT FIT YOUR ${vLabel}${noteLabel}</div>`;
      }
    } catch(e) {
      // Never hard-fail the badge on a network error — show a neutral verify state.
      badgeEl.innerHTML = '<div class="zd-fit-indicator zd-fit-unknown zd-fit-open-btn" role="button" tabindex="0">⚠ SELECT YOUR VEHICLE TO VERIFY FITMENT</div>';
    }
  }

  zdRenderFitmentBadge();
  window.addEventListener('zd:vehicleSelected', zdRenderFitmentBadge);

  // Persistent click delegation on badgeEl — survives innerHTML swaps. Dispatches the same
  // 'zd:openDossier' event the Add-to-Cart modal's "Update Vehicle Details" button uses (zd-app.js
  // listens for it) rather than clicking the toggle directly, so a "LIKELY FITS — select X to
  // confirm" click also rehydrates the dossier to the CURRENT vehicle and flashes the specific
  // field(s) named in `needs` — instead of dropping the customer into an empty picker they'd have
  // to redecode/re-enter (Chuck, 2026-07-22).
  if (badgeEl) {
    badgeEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.zd-fit-open-btn');
      if (!btn) return;
      var needs = (btn.dataset.needs || '').split(',').filter(Boolean);
      window.dispatchEvent(new CustomEvent('zd:openDossier', { detail: { needs: needs } }));
    });
  }

  // ── Cart gate — require fitment confirmation before add-to-cart ──
  // Uses the same authoritative D1 check as the badge, so a fitting part is never
  // blocked and a non-fitting one is never silently added.
  const catalogMarker = document.getElementById('zd-catalog-product');
  const addForm = document.querySelector('[data-type="add-to-cart-form"]');
  const zdVehLabel = () => { try { const v = JSON.parse(localStorage.getItem('zd_vehicle') || 'null'); return (v && v.year && v.make && v.model) ? `${v.year} ${v.make} ${v.model}` : ''; } catch { return ''; } };
  // Stamps/refreshes a hidden "properties[_Shopped Vehicle]" input on the add-to-cart FORM so the
  // vehicle active at add time travels with THAT line item — the cart-level "Shopped Vehicle"
  // attribute (zdTagVehicle below) only ever holds the LAST vehicle selected, so a customer who
  // shops vehicle 1, adds a part, then switches to vehicle 2 and adds another would have BOTH
  // items checked against vehicle 2 post-sale — a false "doesn't match" flag on the first item,
  // which genuinely fit the vehicle it was actually added under (Chuck, 2026-08-07). Idempotent —
  // reuses the same input across repeated submits on this form instead of stacking duplicates.
  function zdSetFormVehicleProp(form) {
    const lbl = zdVehLabel();
    if (!lbl) return;
    let input = form.querySelector('input[name="properties[_Shopped Vehicle]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_Shopped Vehicle]';
      form.appendChild(input);
    }
    input.value = lbl;
  }
  // Tag the CART with the shopped vehicle → lands on the ORDER (admin) for post-sale fitment review.
  async function zdTagVehicle() {
    const lbl = zdVehLabel(); if (!lbl) return;
    try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Shopped Vehicle': lbl } }) }); } catch {}
  }

  // ── FNC (Fitment Not Confirmed) order-note marker ──
  // The "Fitment Bypassed" cart attribute above already proves a bypass happened, but it only
  // shows up in the order's "Additional details" section — easy to miss at a glance. This puts a
  // short, human-readable code (FNC<partNumber>, e.g. "FNC83361") on the actual order NOTE, which
  // Chuck reads first, so a return/warranty request on that part can be met with a restocking fee
  // /return-shipping charge with proof on hand that fitment was never confirmed (Chuck, 2026-08-07).
  // Line 1 of cart.note is reserved for space-separated FNC codes; line 2+ is the customer's own
  // free text (see zdProtectFitmentNotes below, which keeps that split enforced in the cart UI).
  const ZD_FNC_LINE_RE = /^((?:FNC\S+\s*)+)(?:\n([\s\S]*))?$/;
  function zdSplitFitmentNote(note) {
    const m = ZD_FNC_LINE_RE.exec((note || '').replace(/^\s+/, ''));
    if (!m) return { codes: [], rest: note || '' };
    return { codes: m[1].trim().split(/\s+/), rest: m[2] || '' };
  }
  async function zdAppendFitmentNoteCode(code) {
    if (!code) return;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const { codes, rest } = zdSplitFitmentNote(cart.note);
      if (!codes.includes(code)) codes.push(code);
      const newNote = codes.join(' ') + (rest ? `\n${rest}` : '');
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: newNote }) });
    } catch {}
  }
  // Dawn's stock <cart-note> element sends the raw textarea value as the WHOLE cart.note on every
  // edit (see CartNote in cart.js) — left alone, a customer clearing the note box would wipe the
  // FNC codes with it. This strips the FNC line out of the visible/editable textarea into a
  // separate read-only strip (nothing left in the field to delete), and reassembles "codes + their
  // text" server-side on every save. Re-run via MutationObserver below since the cart drawer/page
  // re-renders <cart-note> from scratch (fresh cart.note, un-stripped) after every cart change.
  function zdProtectFitmentNotes() {
    document.querySelectorAll('cart-note').forEach((el) => {
      if (el.dataset.zdFncWired) return;
      const textarea = el.querySelector('textarea[name="note"]');
      if (!textarea) return;
      el.dataset.zdFncWired = '1';

      const { codes, rest } = zdSplitFitmentNote(textarea.value);
      textarea.value = rest;
      if (codes.length) {
        const lock = document.createElement('div');
        lock.className = 'zd-fnc-note-lock';
        lock.textContent = `🔒 Fitment bypass on file (${codes.join(', ')}) — kept on this order automatically`;
        el.insertBefore(lock, textarea);
      }

      let saveTimer;
      el.addEventListener('input', (e) => {
        if (e.target !== textarea) return;
        e.stopImmediatePropagation(); // beats Dawn's own bubble-phase listener on this same element
        clearTimeout(saveTimer);
        saveTimer = setTimeout(async () => {
          try {
            const cart = await fetch('/cart.js').then(r => r.json());
            const { codes: liveCodes } = zdSplitFitmentNote(cart.note);
            const newNote = liveCodes.length ? `${liveCodes.join(' ')}\n${textarea.value}` : textarea.value;
            await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: newNote }) });
          } catch {}
        }, 300);
      }, true); // capture phase — runs before Dawn's listener, which is added without capture
    });
  }
  zdProtectFitmentNotes();
  new MutationObserver(() => zdProtectFitmentNotes()).observe(document.body, { childList: true, subtree: true });
  // "Add Anyway" bypass — add via AJAX with an admin-only fitment note + flag the cart, then open
  // the cart slide-out (same as a normal Add to Cart) instead of redirecting to /cart (Chuck, 2026-07-19).
  async function zdAddBypassed() {
    const fd = new FormData(addForm);
    const id = fd.get('id'); const quantity = Number(fd.get('quantity') || 1);
    const lbl = zdVehLabel();
    const note = lbl ? `⚠ Added WITHOUT confirmed fit — shopped ${lbl}` : '⚠ Added with NO vehicle selected — fitment unverified';
    const pn = (badgeEl?.dataset.pn || '').trim();
    const fncCode = pn ? `FNC${pn.replace(/\s+/g, '')}` : '';
    if (!id) { addForm.dataset.zdFitPass = '1'; return (addForm.requestSubmit ? addForm.requestSubmit() : addForm.submit()); }
    const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    try {
      const props = { '_Fitment': note };
      if (lbl) props['_Shopped Vehicle'] = lbl;
      const body = { items: [{ id, quantity, properties: props }] };
      if (cartEl) { body.sections = cartEl.getSectionsToRender().map((s) => s.id).join(','); body.sections_url = window.location.pathname; }
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Fitment Bypassed': 'yes' } }) }); } catch {}
      if (fncCode) await zdAppendFitmentNoteCode(fncCode);
      if (data.status) { console.error(data.description || data.message); return; }
      if (cartEl) { cartEl.renderContents(data); } else { window.location.href = '/cart'; }
    } catch { addForm.dataset.zdFitPass = '1'; (addForm.requestSubmit ? addForm.requestSubmit() : addForm.submit()); }
  }

  if (addForm && (badgeEl || fitmentEl || catalogMarker)) {
    zdTagVehicle();
    window.addEventListener('zd:vehicleSelected', zdTagVehicle);
    // DOCUMENT-CAPTURE: fires before the theme's product-form submit handler. A form-level capture
    // listener does NOT beat Dawn's target-phase handler (registered earlier) — that's why the item
    // was added BEFORE the modal could block. Document capture always runs first → real block.
    document.addEventListener('submit', e => {
      if (e.target !== addForm) return;
      zdSetFormVehicleProp(addForm); // fresh vehicle on every real submit attempt, gated or not
      if (addForm.dataset.zdFitPass === '1') { addForm.dataset.zdFitPass = ''; return; } // our own re-submit → allow
      if (!zdProductHasFitment()) { zdTagVehicle(); return; }                            // universal → allow
      e.preventDefault();
      e.stopImmediatePropagation();
      let vehicle = null; try { vehicle = JSON.parse(localStorage.getItem('zd_vehicle') || 'null'); } catch {}
      if (!vehicle?.year || !vehicle?.make || !vehicle?.model) { zdShowFitmentModal('no-vehicle', null, addForm); return; }
      zdResolveFitment(vehicle).then(result => {
        if (result.fits) { zdTagVehicle(); addForm.dataset.zdFitPass = '1'; (addForm.requestSubmit ? addForm.requestSubmit() : addForm.submit()); }
        else if (result.likely_fits) zdShowFitmentModal('needs-info', vehicle, addForm, result);
        else zdShowFitmentModal('no-fit', vehicle, addForm, result);
      }).catch(() => zdShowFitmentModal('no-fit', vehicle, addForm)); // lookup failed → GATE (don't silently add)
    }, true);
  }

  // Shared gate check for buttons that never dispatch a 'submit' event at all (Add to Cart's
  // wireCustomAddToCart, and Buy Now — both live in the separate product-page-redesign IIFE
  // further down this file, a different closure entirely, hence window instead of a bare
  // reference) — the document-capture submit listener above only catches real form submissions,
  // so those two need to call this directly before their own fetch.
  // Returns true = proceed, false = blocked (modal already shown).
  async function zdCheckFitmentGate() {
    if (!addForm) return true;
    if (!zdProductHasFitment()) { zdTagVehicle(); return true; }
    let vehicle = null; try { vehicle = JSON.parse(localStorage.getItem('zd_vehicle') || 'null'); } catch {}
    if (!vehicle?.year || !vehicle?.make || !vehicle?.model) { zdShowFitmentModal('no-vehicle', null, addForm); return false; }
    try {
      const result = await zdResolveFitment(vehicle);
      if (result.fits) { zdTagVehicle(); return true; }
      zdShowFitmentModal(result.likely_fits ? 'needs-info' : 'no-fit', vehicle, addForm, result);
      return false;
    } catch {
      zdShowFitmentModal('no-fit', vehicle, addForm); // lookup failed → GATE (don't silently add)
      return false;
    }
  }
  window.zdCheckFitmentGate = zdCheckFitmentGate;

  function zdShowFitmentModal(mode, vehicle, form, result) {
    if (document.getElementById('zd-fitment-modal')) return;
    const noteLine = result?.notes?.length ? `<br><br><em>${result.notes[0]}</em>` : '';
    const title = mode === 'no-fit' ? `⚠ Part May Not Fit Your ${vehicle.year} ${vehicle.make} ${vehicle.model}`
      : mode === 'needs-info' ? `⚠ Need a Bit More Detail`
      : '⚠ No Vehicle Selected';
    const body = mode === 'no-fit'
      ? `Our fitment data shows this part does not match your selected vehicle. You can still purchase, but fitment is not guaranteed.${noteLine}`
      : mode === 'needs-info'
      ? `We need your ${zdNeedsText(result.needs)} to confirm this fits your ${vehicle.year} ${vehicle.make} ${vehicle.model}. Select it above, or add anyway — fitment is not guaranteed.${noteLine}`
      : 'This part has specific vehicle fitment requirements. Add your vehicle for a guaranteed fit, or proceed without confirmation.';

    const modal = document.createElement('div');
    modal.id = 'zd-fitment-modal';
    modal.innerHTML = `
      <div class="zd-fm-overlay"></div>
      <div class="zd-fm-box">
        <div class="zd-fm-title">${title}</div>
        <div class="zd-fm-body">${body}</div>
        <div class="zd-fm-actions">
          <button class="zd-fm-btn zd-fm-add" id="zd-fm-proceed">Add Anyway — No Fitment Guarantee</button>
          <button class="zd-fm-btn zd-fm-vehicle" id="zd-fm-select">${mode === 'needs-info' ? 'Update Vehicle Details' : 'Select Vehicle'}</button>
        </div>
      </div>`;
    document.body.appendChild(modal);

    document.getElementById('zd-fm-proceed').addEventListener('click', () => {
      modal.remove();
      zdAddBypassed();   // AJAX add with the admin-only fitment note (form.submit() bypassed it + our tagging)
    });
    document.getElementById('zd-fm-select').addEventListener('click', () => {
      modal.remove();
      document.getElementById('zd-category-toggle')?.dispatchEvent(new MouseEvent('click'));
      // Open dossier already hydrated to the current vehicle, flashing whichever field(s) are
      // still needed (empty for 'no-fit'/'no-vehicle' modes, where result.needs doesn't apply).
      window.dispatchEvent(new CustomEvent('zd:openDossier', { detail: { needs: result?.needs || [] } }));
    });
    modal.querySelector('.zd-fm-overlay').addEventListener('click', () => modal.remove());
  }

  // Homepage category tiles now navigate to their /collections/<handle> landing pages like any
  // other link. The old tile interceptor (hardcoded pre-2026-09-22 category names) was removed:
  // its only surviving match was "engine", so the Engine tile alone was hijacked into toggling
  // the Browse tree (clicking it with the tree open just closed it) — Chuck, 2026-10-03.

  // ── CATALOG nav link — open Browse tree instead of /collections/all ──
  function interceptCatalogNav() {
    const links = document.querySelectorAll('a[href*="/collections/all"], a[href="/collections"]');
    links.forEach(link => {
      // Never hijack the cart drawer's own links ("Continue shopping" / "View cart" both point
      // at /collections/all or /cart) — this was swallowing "Continue shopping" clicks entirely,
      // silently opening the browse-tree panel instead of navigating (Chuck, 2026-07-19).
      if (link.closest('cart-drawer, .cart-drawer, .drawer')) return;      const txt = (link.textContent || '').trim().toUpperCase();
      if (txt === 'CATALOG' || txt === 'SHOP' || link.href.includes('/collections/all')) {
        link.addEventListener('click', e => {
          const toggle = document.getElementById('zd-category-toggle');
          if (toggle) {
            e.preventDefault();
            toggle.click();
          }
        });
      }
    });
  }
  interceptCatalogNav();

  // Cart "Continue shopping" buttons: close the drawer and open the Browse tree over the page the
  // shopper is already on, instead of dumping them on /collections/all. Falls back to the link
  // if the tree isn't on the page.
  document.addEventListener('click', e => {
    const link = e.target.closest('a[data-zd-continue]');
    if (!link) return;
    const toggle = document.getElementById('zd-category-toggle');
    if (!toggle) return;
    e.preventDefault();
    const drawer = link.closest('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    if (!document.getElementById('zd-left-panel')?.classList.contains('open')) toggle.click();
  });


  // ── #4 Subcategory filter pills on collection pages ────────
  const ZD_WORKER = 'https://zda-engine.tight-voice-31e4.workers.dev';
  // Emptied on purpose: this was a pre-2026-09-22 handle map, and its only live match (engine) put
  // stale search-link filter pills on the Engine collection page only. Collection sub-tiles are
  // being redesigned (see project_collections_cleanup_and_landing_design).
  const ZD_HANDLE_MAP = {};

  const pathParts = window.location.pathname.split('/').filter(Boolean);
  if (pathParts[0] === 'collections' && pathParts[1] && ZD_HANDLE_MAP[pathParts[1]]) {
    const handle  = pathParts[1];
    const zdMain  = ZD_HANDLE_MAP[handle];
    const grid    = document.querySelector('.collection-product-list, .product-grid, ul.grid');

    if (grid) {
      fetch(`${ZD_WORKER}/zd-catalog/tree`)
        .then(r => r.json())
        .then(({ tree }) => {
          const subs = (tree[zdMain] || []).map(s => s.sub).filter(Boolean);
          if (!subs.length) return;

          const vehicle = JSON.parse(localStorage.getItem('zd_vehicle') || 'null');
          const wrap = document.createElement('div');
          wrap.className = 'zd-subcat-filters';

          const allBtn = document.createElement('a');
          allBtn.className = 'zd-filter-pill zd-filter-pill--active';
          allBtn.textContent = 'All';
          allBtn.href = `/collections/${handle}`;
          wrap.appendChild(allBtn);

          subs.forEach(sub => {
            const pill = document.createElement('a');
            pill.className = 'zd-filter-pill';
            pill.textContent = sub;
            if (vehicle?.make && vehicle?.model) {
              const q = encodeURIComponent([vehicle.make, vehicle.model, sub].join(' '));
              pill.href = `/search?type=product&q=${q}&filter.p.tag=zd-${handle}`;
            } else {
              const q = encodeURIComponent(sub);
              pill.href = `/search?type=product&q=${q}&filter.p.tag=zd-${handle}`;
            }
            wrap.appendChild(pill);
          });

          grid.parentElement.insertBefore(wrap, grid);
        })
        .catch(() => {});
    }
  }
});

function zdMoveVideoToStrip() {
  if (document.querySelector('.zd-video-thumb-li')) return;
  var videoBtn = document.querySelector('.zd-video-block .zd-video-btn')
    || document.querySelector('#zd-gallery-video-slot .zd-video-btn');
  var thumbList = document.querySelector('.thumbnail-list');
  if (!videoBtn || !thumbList) return;

  // Match exact pixel size of existing thumbnails so flex row doesn't stretch
  var refLi = thumbList.querySelector('.thumbnail-list__item:not(.zd-video-thumb-li)');
  var thumbW = refLi ? refLi.offsetWidth  : 72;
  var thumbH = refLi ? refLi.offsetHeight : 72;

  var li = document.createElement('li');
  li.className = 'thumbnail-list__item slider__slide zd-video-thumb-li';
  li.style.cssText = 'width:' + thumbW + 'px; height:' + thumbH + 'px; flex-shrink:0; overflow:hidden;';

  var media = document.createElement('div');
  media.style.cssText = 'position:relative; width:100%; height:100%; overflow:hidden;';
  media.appendChild(videoBtn);
  li.appendChild(media);
  thumbList.appendChild(li);

  var origBlock = document.querySelector('.zd-video-block');
  if (origBlock) origBlock.style.display = 'none';
}
window.addEventListener('load', zdMoveVideoToStrip);

// ── Product image lightbox: touch-tap-outside-to-close ──
// Dawn's own outside-tap dismiss (global.js ModalDialog) only fires for
// pointerType 'mouse', so touch shoppers had no way to back out of the
// expanded image besides the small corner X. Add the touch equivalent.
document.addEventListener('pointerup', (e) => {
  if (e.pointerType !== 'touch') return;
  const modal = e.target.closest('.product-media-modal');
  if (modal && e.target === modal && typeof modal.hide === 'function') modal.hide();
});

// ── Product image lightbox: back/forth arrows to switch photos while expanded ──
// Dawn's stock modal has no way to move between photos once zoomed in besides scrolling
// (desktop, where every image is stacked and visible) or nothing at all (mobile, where
// product-modal.js's showActiveMedia() hides every image except the one that was tapped via
// `display:none`) — Chuck wanted visible prev/next arrows instead (2026-07-22). Reuses the same
// [data-media-id]/.active convention product-modal.js already maintains rather than duplicating
// its state.
(function () {
  function wireArrows(modal) {
    if (modal.querySelector('.zd-modal-arrow')) return;
    const dialog = modal.querySelector('.product-media-modal__dialog');
    const content = modal.querySelector('.product-media-modal__content');
    if (!dialog || !content) return;
    const items = [...content.querySelectorAll(':scope > [data-media-id]')];
    if (items.length < 2) return; // nothing to switch between

    const makeBtn = (dir, label) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `zd-modal-arrow zd-modal-arrow--${dir}`;
      btn.setAttribute('aria-label', label);
      btn.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
      // Dawn's ModalDialog (global.js) binds its own dismiss listener directly on the modal
      // element for `pointerup` — not `click` — for any mouse pointerup whose target isn't inside
      // a <deferred-media>/<product-model>. That fires (and closes the modal) BEFORE this button's
      // own 'click' handler ever runs, since pointerup precedes click in the event sequence — so
      // stopping propagation only on 'click' was too late (Chuck, 2026-07-22: arrows were closing
      // the lightbox instead of switching photos). Stop it at the source on 'pointerup' too.
      btn.addEventListener('pointerup', (e) => e.stopPropagation());
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const curIdx = items.findIndex((el) => el.classList.contains('active'));
        const step = dir === 'prev' ? -1 : 1;
        const nextIdx = ((curIdx < 0 ? 0 : curIdx) + step + items.length) % items.length;
        items[curIdx]?.classList.remove('active');
        items[nextIdx].classList.add('active');
        items[nextIdx].scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return btn;
    };
    dialog.appendChild(makeBtn('prev', 'Previous photo'));
    dialog.appendChild(makeBtn('next', 'Next photo'));
  }
  document.querySelectorAll('.product-media-modal').forEach(wireArrows);
})();

// Brand page "jump to another brand" dropdown (main-collection-banner.liquid) — custom-built
// (not a native <select>, whose options popup can't be reliably dark-themed cross-browser).
// Reuses the same brand-marquee data source as the homepage scroller — one list to maintain.
(function () {
  const btn = document.getElementById('zd-brand-jump-btn');
  const dd = document.getElementById('zd-brand-jump-dd');
  const input = document.getElementById('zd-brand-jump-input');
  const list = document.getElementById('zd-brand-jump-list');
  if (!btn || !dd || !input || !list) return;

  let brands = [];
  // Always re-read the CURRENT input value rather than capturing it at call time — the brand
  // list fetch resolves asynchronously, and if it just did `render(brands)` unconditionally on
  // resolve, it would blow away whatever the user had already typed (a real bug: typing fast
  // right after opening the dropdown raced the fetch and showed stale/wrong results).
  function renderFiltered() {
    const q = input.value.trim().toLowerCase();
    const items = q ? brands.filter(b => b.name.toLowerCase().includes(q)) : brands;
    list.innerHTML = '';
    if (!items.length) {
      list.innerHTML = '<div class="zd-brand-jump-empty">No matching brands</div>';
      return;
    }
    items.forEach(b => {
      const a = document.createElement('a');
      a.href = '/collections/' + b.handle;
      a.textContent = b.name;
      list.appendChild(a);
    });
  }

  fetch('https://zda-engine.tight-voice-31e4.workers.dev/theme/config?key=brand-marquee')
    .then(r => r.json())
    .then(d => {
      brands = (d.data || []).filter(b => b.active !== false && b.handle)
        .sort((a, b) => a.name.localeCompare(b.name));
      renderFiltered();
    })
    .catch(() => {});

  function close() {
    dd.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
  }
  function open() {
    dd.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      // Fixed positioning on mobile (see CSS) needs its own top — the button can land
      // anywhere depending on how long the collection title is, so compute it live.
      dd.style.top = (btn.getBoundingClientRect().bottom + 8) + 'px';
    } else {
      // Autofocus is a nice convenience on desktop (keyboard's already up); on mobile it
      // just pops the on-screen keyboard over a list most people want to scroll, not type
      // into (Chuck, 2026-07-19).
      input.focus();
    }
    renderFiltered();
  }

  btn.addEventListener('click', () => dd.classList.contains('open') ? close() : open());
  input.addEventListener('input', renderFiltered);
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.zd-brand-jump-wrap')) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

// Brand page YouTube install videos — only one plays at a time (Chuck: don't let two videos
// play/overlap audio at once). Iframes need enablejsapi=1 in their src (set at write time) for
// the postMessage API to work; loads the IFrame API once, wires every .zd-brand-video iframe.
(function () {
  const frames = document.querySelectorAll('.zd-brand-video iframe');
  if (!frames.length) return;
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);

  window.onYouTubeIframeAPIReady = function () {
    const players = [...frames].map(f => new YT.Player(f, {
      events: {
        onStateChange: (e) => {
          if (e.data !== YT.PlayerState.PLAYING) return;
          players.forEach(p => { if (p !== e.target) p.pauseVideo(); });
        },
      },
    }));
  };
})();

// Product page redesign (Chuck, 2026-07-17) — one-screen desktop layout: tabbed product info
// instead of a stacked accordion, a compact buy row (qty + Add to Cart + Buy Now), and the
// stock indicator paired with Share. All progressive enhancement over Dawn's existing markup —
// if this script fails to load, the page still works as plain native <details> accordions and a
// full-width Add to Cart button.
(function () {
  // ── 1. Tab controller ───────────────────────────────────────────────────
  // "Description & Features"/"Specifications"/"Packaging Information"/"Safety"/"Warranty"/
  // "⚠ Fitment Notes" are NOT theme-editor blocks — they're <details> elements baked directly
  // into product.description HTML by push-product (zd-worker.js), with "Description & Features"
  // and "⚠ Fitment Notes" hardcoded open. Changing that at the source means re-pushing every
  // product's body_html. Instead this reads whatever <details> already exist at runtime and
  // turns them into tabs — works instantly on the whole existing catalog AND every future push.
  const descBox = document.querySelector('.product__description');
  const detailsList = descBox ? [...descBox.querySelectorAll('details')] : [];
  // The Vehicle Fitment accordion (year/make/model ranges) is a separate hardcoded block,
  // rendered after the block loop — merge it into the same tab set rather than leaving it as
  // its own accordion below the tabs.
  const fitmentAccordion = document.querySelector('[id^="Details-fitment-"]');
  if (fitmentAccordion) {
    const wrapper = fitmentAccordion.closest('.product__accordion') || fitmentAccordion.parentElement;
    fitmentAccordion._zdWrapper = wrapper;
    detailsList.push(fitmentAccordion);
  }

  if (detailsList.length) {
    const bar = document.createElement('div');
    bar.className = 'zd-tabs-bar';
    const panelHost = document.createElement('div');
    panelHost.className = 'zd-tabs-panels';

    detailsList.forEach((details, i) => {
      const summary = details.querySelector('summary');
      const label = (summary?.textContent || `Tab ${i + 1}`).trim();
      const key = label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `tab-${i}`;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zd-tab-btn';
      btn.dataset.tabKey = key;
      btn.textContent = label;
      bar.appendChild(btn);

      const panel = document.createElement('div');
      panel.className = 'zd-tab-panel';
      panel.dataset.tabKey = key;
      // Move every child except <summary> into the panel — keeps the original accordion content
      // (tables, lists, rich text) exactly as push-product built it, no re-authoring needed.
      [...details.childNodes].forEach((node) => {
        if (node !== summary) panel.appendChild(node);
      });
      panelHost.appendChild(panel);
    });

    // Reviews — Judge.me installs its review widget as its own standalone section at the very
    // bottom of the page (below Related Products), completely outside the tab system (Chuck,
    // 2026-07-18: "just a leave a review [block]... doesn't do much"). Move it into a "Reviews"
    // tab instead so the one-screen design isn't broken by a whole section dangling below the
    // fold. `#judgeme_product_reviews` is Judge.me's own stable widget id (not ours to control) —
    // safe to relocate since its script finds the element by id regardless of DOM position, and
    // zd-theme.js loads `defer`, so the whole page (including this trailing section) is already
    // parsed by the time this runs.
    const reviewWidget = document.getElementById('judgeme_product_reviews');
    if (reviewWidget) {
      const reviewSection = reviewWidget.closest('.shopify-section');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zd-tab-btn';
      btn.dataset.tabKey = 'reviews';
      btn.textContent = 'Reviews';
      bar.appendChild(btn);

      const panel = document.createElement('div');
      panel.className = 'zd-tab-panel';
      panel.dataset.tabKey = 'reviews';
      panel.appendChild(reviewWidget);
      panelHost.appendChild(panel);
      reviewSection?.remove();
    }

    // Fixed tab order (Chuck, 2026-11-03). Tabs also arrive late from zd-smtp-sandbox.liquid, which calls this again after it adds its own.
    window.zdSortTabs = function (tabBar, panels) {
      const rank = (label) => {
        const t = label.toLowerCase();
        if (t.indexOf('description') !== -1) return 1;
        if (t.indexOf('state sale') !== -1) return 2;
        if (t.indexOf('specification') !== -1) return 3;
        if (t.indexOf('fitment notes') !== -1) return 4.2;
        if (t.indexOf('fitment') !== -1) return 4;
        if (t.indexOf('packaging') !== -1) return 5;
        if (t.indexOf('cross reference') !== -1) return 6;
        if (t.indexOf('safety') !== -1) return 7;
        if (t.indexOf('warranty') !== -1) return 8;
        if (t.indexOf('reviews') !== -1) return 10;
        return 9;
      };
      const byKey = {};
      panels.querySelectorAll('.zd-tab-panel').forEach((p) => { byKey[p.dataset.tabKey] = p; });
      [...tabBar.querySelectorAll('.zd-tab-btn')]
        .map((b, i) => ({ b, i, r: rank(b.textContent) }))
        .sort((x, y) => x.r - y.r || x.i - y.i)
        .forEach(({ b }) => { tabBar.appendChild(b); if (byKey[b.dataset.tabKey]) panels.appendChild(byKey[b.dataset.tabKey]); });
    };
    window.zdSortTabs(bar, panelHost);

    function activateTab(btn) {
      bar.querySelectorAll('.zd-tab-btn').forEach((b) => b.classList.remove('active'));
      panelHost.querySelectorAll('.zd-tab-panel').forEach((p) => p.classList.remove('active'));
      btn.classList.add('active');
      panelHost.querySelector(`.zd-tab-panel[data-tab-key="${btn.dataset.tabKey}"]`)?.classList.add('active');
    }
    bar.querySelectorAll('.zd-tab-btn').forEach((btn) => {
      btn.addEventListener('click', () => activateTab(btn));
      // File-cabinet feel (Chuck, 2026-07-17 round 2): a folder opens as soon as you point at its
      // tab, not just on click. Touch devices have no hover state, so click still works there.
      // 140ms hover-intent delay (Chuck, 2026-07-26 — same debounce used for the category tree's
      // hover cascade in zda-builder/zd-app.js): on narrower widths the tab bar wraps to multiple
      // rows, so reaching a long open panel below (e.g. to scroll and read Description & Features)
      // routinely grazed a lower-row tab like Fitment/Fitment Notes on the way past, instantly
      // swapping the open tab out from under the reader. A quick pass-through now cancels before
      // the delay elapses; only a genuine pause on a tab opens it.
      let hoverTimer = null;
      btn.addEventListener('mouseenter', () => {
        hoverTimer = setTimeout(() => activateTab(btn), 140);
      });
      btn.addEventListener('mouseleave', () => {
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      });
    });
    // Default: only the first tab (always "Description & Features", per push-product's build
    // order) starts open — every other panel, including the rare "⚠ State Sale Restriction" and
    // "⚠ Fitment Notes" details that ship open-by-default today, is now a normal closed tab.
    bar.firstElementChild?.classList.add('active');
    panelHost.firstElementChild?.classList.add('active');

    const tabsWrap = document.createElement('div');
    tabsWrap.className = 'zd-product-tabs';
    tabsWrap.appendChild(bar);
    tabsWrap.appendChild(panelHost);

    // "Below everything, full width" (Chuck, 2026-07-17 round 2) — the tab bar + panels move
    // out of the narrow info column entirely and become their own full-width block directly
    // under the image+info two-column row, instead of being confined to the info column's width.
    descBox?.remove();
    fitmentAccordion?._zdWrapper?.remove();
    const productGrid = document.querySelector('.product.grid');
    if (productGrid?.parentElement) {
      productGrid.parentElement.insertBefore(tabsWrap, productGrid.nextSibling);
    } else {
      document.querySelector('.product__info-container')?.appendChild(tabsWrap);
    }

    // Cap the panel to whatever vertical space is left below it and scroll internally past that —
    // otherwise a long Description & Features panel (variable per product) pushes the page past
    // one screen on shorter viewports (1440x900), defeating the whole point of the tab redesign.
    // Mobile ALSO needs this (Chuck, 2026-07-26): originally left uncapped on the theory "mobile
    // already scrolls the full page" — but a product with a long title/fitment list (Vehicle
    // Fitment or Fitment Notes tabs) turned that into a genuinely never-ending scroll, since
    // mobile's stacked layout has no side content to bound the panel's growth the way desktop's
    // two-column layout naturally does. Mobile uses a flat vh-based cap instead of desktop's
    // "remaining viewport below the panel" formula — the panel's top position on mobile is already
    // far down the page (image + info stack above it), so "remaining space below" would often be
    // too small to be useful.
    const MIN_PANEL_HEIGHT = 160;
    const BOTTOM_BREATHING_ROOM = 24;
    const MOBILE_MAX_HEIGHT_VH = 50;
    function fitPanelHeight() {
      if (!window.matchMedia('(min-width: 750px)').matches) {
        panelHost.style.maxHeight = MOBILE_MAX_HEIGHT_VH + 'vh';
        panelHost.style.overflowY = 'auto';
        return;
      }
      const top = panelHost.getBoundingClientRect().top;
      const available = window.innerHeight - top - BOTTOM_BREATHING_ROOM;
      panelHost.style.maxHeight = Math.max(available, MIN_PANEL_HEIGHT) + 'px';
      panelHost.style.overflowY = 'auto';
    }
    let fitTimer;
    function fitPanelHeightDebounced() {
      clearTimeout(fitTimer);
      fitTimer = setTimeout(fitPanelHeight, 100);
    }
    requestAnimationFrame(fitPanelHeight);
    window.addEventListener('resize', fitPanelHeightDebounced);
    // A single rAF right after insertion measures too early — the main product image hasn't
    // loaded/laid out yet, so panelHost.top is still its pre-image position and the resulting
    // max-height is too generous once the image pushes everything down. Re-measure whenever
    // anything above the panel changes size (image load, font swap, fitment badge async render)
    // instead of guessing with a fixed delay.
    if (window.ResizeObserver) {
      new ResizeObserver(fitPanelHeightDebounced).observe(document.querySelector('.product__media-wrapper') || document.body);
    } else {
      window.addEventListener('load', fitPanelHeight);
    }
  }

  // ── 2. Buy row — qty selector + Add to Cart + Buy Now in one row ───────
  // Relocating .product-form__buttons out of <product-form> works visually, but if it runs
  // BEFORE product-form.js's custom element constructor fires, that constructor's own
  // `this.querySelector('[type="submit"]')` comes back null (button already moved) and throws —
  // which skips wiring up its AJAX submit handler entirely, so Add to Cart silently does nothing
  // (Chuck, 2026-07-18). customElements.whenDefined() guarantees the constructor — which runs
  // synchronously inside define() — has already fired before we move anything.
  const qtyForm = document.querySelector('[id^="Quantity-Form-"]');
  const addCartBtn = document.querySelector('.zd-btn-addcart');
  const buyNowBtn = document.querySelector('.zd-btn-buynow');
  function assembleBuyRow() {
    if (!qtyForm || !addCartBtn) return;
    const row = document.createElement('div');
    row.className = 'zd-buy-row';
    qtyForm.replaceWith(row);
    row.appendChild(qtyForm);
    const buttonsWrap = addCartBtn.closest('.product-form__buttons') || addCartBtn.parentElement;
    row.appendChild(buttonsWrap);
  }

  // Something in native form submission (or the resulting `submit` event) redirects to Shopify's
  // hosted customer-account sign-in instead of adding to cart — reproduces on every product, with
  // nothing in our own code intercepting it (Chuck, 2026-07-19). Buy Now never has this problem
  // because it never submits the form — it just fetches '/cart/add.js' directly. So Add to Cart
  // gets the same treatment: switched to type="button" (done here, AFTER product-form.js's
  // constructor has already captured its `this.submitButton` reference, so that reference stays
  // valid even though the type attribute changes under it) with its own click handler that
  // mirrors Dawn's product-form.js onSubmitHandler (same fetch, same cart-drawer render call)
  // but is never wired through the form's submit event at all.
  // Same vehicle-label read as zdVehLabel() in the fitment-gate closure above — duplicated here
  // (not shared via `window`) because it's a one-line localStorage read, cheaper to repeat than
  // to plumb through. Used to stamp "_Shopped Vehicle" on every add from THIS closure's two AJAX
  // add-to-cart paths (custom Add to Cart button + Buy Now), which never touch the product form's
  // submit event at all, so zdSetFormVehicleProp's form-input approach can't reach them.
  const zdVehLabel2 = () => { try { const v = JSON.parse(localStorage.getItem('zd_vehicle') || 'null'); return (v && v.year && v.make && v.model) ? `${v.year} ${v.make} ${v.model}` : ''; } catch { return ''; } };

  function wireCustomAddToCart() {
    if (!addCartBtn) return;
    const formEl = addCartBtn.closest('[data-type="add-to-cart-form"]') || document.querySelector('[data-type="add-to-cart-form"]');
    if (!formEl) return;
    addCartBtn.setAttribute('type', 'button');
    const spinner = addCartBtn.querySelector('.loading__spinner');

    addCartBtn.addEventListener('click', async function (evt) {
      evt.preventDefault();
      if (addCartBtn.getAttribute('aria-disabled') === 'true') return;
      if (!(await window.zdCheckFitmentGate())) return; // gate: this click never fires a 'submit' event

      addCartBtn.setAttribute('aria-disabled', 'true');
      addCartBtn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData(formEl);
      const vehLbl = zdVehLabel2();
      if (vehLbl && !formData.has('properties[_Shopped Vehicle]')) formData.append('properties[_Shopped Vehicle]', vehLbl);
      if (cartEl) {
        formData.append('sections', cartEl.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
        cartEl.setActiveElement(document.activeElement);
      }

      try {
        const res = await fetch(routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        const data = await res.json();
        if (data.status) {
          console.error(data.description || data.message);
        } else if (cartEl) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zd-add-to-cart', productVariantId: formData.get('id'), cartData: data });
          }
          cartEl.renderContents(data);
        } else {
          window.location.href = routes.cart_url;
        }
      } catch (e) {
        console.error(e);
      } finally {
        addCartBtn.classList.remove('loading');
        addCartBtn.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }
    });
  }

  if (customElements.get('product-form')) {
    assembleBuyRow();
    wireCustomAddToCart();
  } else {
    customElements.whenDefined('product-form').then(function () {
      assembleBuyRow();
      wireCustomAddToCart();
    });
  }

  // ── 3. Stock row — inventory indicator + Share in one row ──────────────
  const inventoryEl = document.querySelector('[id^="Inventory-"]');
  const shareEl = document.querySelector('share-button');
  if (inventoryEl && shareEl) {
    const row = document.createElement('div');
    row.className = 'zd-stock-row';
    inventoryEl.replaceWith(row);
    row.appendChild(inventoryEl);
    row.appendChild(shareEl);
  }

  // ── 3b. Prop 65 warning — moves under the photos (Chuck, 2026-07-17 round 2), out of the
  // buy-row column, freeing that column up for just qty/cart/buy-now.
  const prop65 = document.querySelector('.zd-prop65-link');
  const mediaWrapper = document.querySelector('.product__media-wrapper');
  if (prop65 && mediaWrapper) {
    mediaWrapper.appendChild(prop65);
  }

  // ── 4. Buy Now — adds to cart via the same AJAX path as Add to Cart, then goes straight to
  // /cart. Deliberately never calls a Shopify payment/dynamic-checkout endpoint — see the policy
  // comment in buy-buttons.liquid; checkout must always start from our gated cart, not bypass it.
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', async () => {
      if (!(await window.zdCheckFitmentGate())) return; // Buy Now never submits the form — gate it directly
      const formEl = document.getElementById(buyNowBtn.dataset.formId);
      if (!formEl) return;
      buyNowBtn.classList.add('loading');
      buyNowBtn.disabled = true;
      try {
        const vehLbl = zdVehLabel2();
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: formEl.querySelector('[name="id"]')?.value,
            quantity: Number(formEl.querySelector('[name="quantity"]')?.value) || 1,
            properties: vehLbl ? { '_Shopped Vehicle': vehLbl } : undefined,
          }),
        });
        if (!res.ok) throw new Error('add to cart failed');
        window.location.href = '/cart';
      } catch (e) {
        buyNowBtn.classList.remove('loading');
        buyNowBtn.disabled = false;
      }
    });
  }
})();

// Product page — cap the vertical thumbnail column to the main image's actual rendered height
// (Chuck, 2026-07-18). The column's own CSS max-height (52rem, zd-theme.css) is just a ceiling
// for very tall viewports — a product with many photos was growing the thumbnail strip taller
// than the main image itself before its internal scroll kicked in. The real cap is whatever
// height the main image renders at, which varies by viewport width since it's a fixed 1:1
// square (aspect-ratio locked via padding-top:100%).
(function () {
  const thumbCol = document.querySelector('media-gallery > slider-component.thumbnail-slider');
  const mainMedia = document.querySelector('media-gallery > slider-component:not(.thumbnail-slider)');
  if (!thumbCol || !mainMedia) return;

  let fitTimer;
  function fitThumbnailHeight() {
    if (!window.matchMedia('(min-width: 750px)').matches) {
      thumbCol.style.maxHeight = '';
      return;
    }
    const h = mainMedia.getBoundingClientRect().height;
    if (h > 0) thumbCol.style.maxHeight = h + 'px';
  }
  function fitThumbnailHeightDebounced() {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitThumbnailHeight, 100);
  }
  requestAnimationFrame(fitThumbnailHeight);
  window.addEventListener('resize', fitThumbnailHeightDebounced);
  if (window.ResizeObserver) {
    new ResizeObserver(fitThumbnailHeightDebounced).observe(mainMedia);
  } else {
    window.addEventListener('load', fitThumbnailHeight);
  }
})();
